const LogoFull = () => {
  return <img src="/logos/SCALAR-logo.svg" width={180} alt="SCALAR logo" />;
};

export default LogoFull;
